export default class ProcessadorTelaFormulario {
    constructor({
        processadorAtribuicao,
        processadorFluxos,
        processadorMapeamento,
        processadorAnexo,
    }) {
        this.processadorAtribuicao = processadorAtribuicao;
        this.processadorFluxos = processadorFluxos;
        this.processadorMapeamento = processadorMapeamento;
        this.processadorAnexo = processadorAnexo;
    }

    async processar({ dados, tela, atribuicoes }) {
        this.processadorMapeamento.processar({ dados, tela, atribuicoes });
        if (tela.atribuicoes) {
            for (const atribuicao of tela.atribuicoes) {
                await this.processadorAtribuicao.processar({
                    dados,
                    atribuicao,
                    atribuicoes,
                });
            }
        }

        this.processadorAnexo.processar({ dados, tela, atribuicoes });

        return this.processadorFluxos.processar({ dados, fluxos: tela.fluxos });
    }
}
